<template>
	<div>
	<div class="container-fluid" v-if="workspace_store.has_workspace">
		<div class="row">
			<div class="col-12">
				<ScreenerMenu :base_date="base_date" />
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<ScreenerTable />
			</div>
		</div>
	</div>
		<AddMetricModal :base_date="base_date" />
		<FilterColumnModal />
		<MoveColumnModal />
		<BulkMetricsModal />
		<AddStrategyModal :is_open="modal_store.current_modal == 'add_strategy'"/>
	</div>
</template>

<script setup>
</script>

<script>
import ScreenerMenu from '@/components/ScreenerMenu.vue'
import AddMetricModal from '@/modals/AddMetricModal.vue'
import MoveColumnModal from '@/modals/MoveColumnModal.vue'
import BulkMetricsModal from '@/modals/BulkMetricsModal.vue'
import FilterColumnModal from '@/modals/FilterColumnModal.vue'
import ScreenerTable from '@/components/ScreenerTable.vue'
import AddStrategyModal from '@/modals/AddStrategyModal.vue'
import { use_load_store } from '@/stores/load.js'
import { use_company_store } from '@/stores/company.js'
import { use_column_store } from '@/stores/column.js'
import { use_workspace_store } from '@/stores/workspace.js'
import { use_metric_store } from '@/stores/metric.js'
import { use_modal_store } from '@/stores/modal.js'
import { use_config_store } from '@/stores/config.js'

async function load_data(to, from, next) {
	const load = use_load_store()

	await load.wrap(async () => {
		const metric_store = use_metric_store()
		await metric_store.fetch_categories()
		await metric_store.fetch_metrics()

		const company_store = use_company_store()
		await company_store.fetch_companies(to.params.base_date || null)

		const workspace_store = use_workspace_store()
		workspace_store.workspace_picker_base_url = "/workspace/"
		await workspace_store.fetch_workspaces(parseInt(to.params.workspace_id || 0))

		if (workspace_store.active_workspace_id > 0) {
			const config_store = use_config_store()
			await config_store.set_config('current_workspace_id', workspace_store.active_workspace_id)
		}

		const column_store = use_column_store()
		await column_store.fetch_columns(true, to.params.base_date || null)
	})
	next()
}

export default {
	name: 'ScreenerView',
	components: {
		ScreenerMenu,
		ScreenerTable,
		AddMetricModal,
		MoveColumnModal,
		BulkMetricsModal,
		FilterColumnModal,
		AddStrategyModal,
	},
	props: {

		workspace_id: {
			type: Number,
			default: 0,
		},

		base_date: {
			type: String,
			default: null,
		},

	},
	setup() {

		const workspace_store = use_workspace_store()
		const modal_store = use_modal_store()

		return {
			workspace_store,
			modal_store,
		}
	},
	async beforeRouteEnter(to, from, next) {

		await load_data(to, from, next)
		
	},
	async beforeRouteUpdate(to, from, next) {
		
		await load_data(to, from, next)

	},
}
</script>
